import ReactGA from "react-ga4";
import {GoogleAnalyticsEventCategory, GoogleAnalyticsEventType} from "../models/google-analytics";
import {isLocalhost} from "./environment-service";

// Wyciągnięte do consta żeby łatwo zmienić w jednym miejscu (np. inny ID na staging).
const GA_MEASUREMENT_ID = "G-XK3JNR74PF";

/** CZY UŻYTKOWNIK ZGODZIŁ SIĘ NA COOKIES ANALITYCZNE => BEZ TEGO NIE WYSYŁAMY PAGEVIEW ANI EVENTÓW */
let analyticsConsentGranted: boolean = false;

/** TRACKOWANIE EVENTÓW */
export function trackEvent(eventType: GoogleAnalyticsEventType) {
    // NA LOCALHOST NIE WYSYŁAMY DO GA
    if (isLocalhost()) return;

    // BEZ ZGODY NA ANALITYKĘ GA NIE DZIAŁA (FAK-28914, T1/T2)
    if (!ReactGA.isInitialized || !analyticsConsentGranted) return;

    handleTrackEvent(eventType);
}

/** TRACKOWANIE PAGEVIEW => gatsby-browser.js (onRouteUpdate) ORAZ PO WYRAŻENIU ZGODY W BANERZE */
export function trackPageview(page: string) {
    if (isLocalhost()) return;
    if (!ReactGA.isInitialized || !analyticsConsentGranted) return;

    ReactGA.send({
        hitType: "pageview",
        page: page
    });
}

function handleTrackEvent(eventType: GoogleAnalyticsEventType) {
    ReactGA.event({
        category: GoogleAnalyticsEventCategory.FakturomaniaWebsite,
        action: eventType,
        label: 'success'
    });
}

/**
 * Wołane z cookie-consent-service.ts po każdej decyzji w banerze (i przy wejściu, gdy zgoda jest już zapisana).
 *
 * Tryb podstawowy Consent Mode (FAK-28914, T2): gtag NIE jest ładowany, dopóki użytkownik nie zgodzi się
 * na analitykę albo marketing. Przy ładowaniu stan domyślny „denied” dla wszystkich 4 sygnałów
 * idzie do dataLayer PRZED poleceniem config.
 */
export function handleUpdateGA4Consent(
    analytics: boolean,
    advertising: boolean
) {
    analyticsConsentGranted = analytics;

    // NA LOCALHOST GA NIE JEST INICJALIZOWANY
    if (isLocalhost()) return;

    const consentState = {
        'ad_storage': advertising ? 'granted' : 'denied',
        'ad_user_data': advertising ? 'granted' : 'denied',
        'ad_personalization': advertising ? 'granted' : 'denied',
        'analytics_storage': analytics ? 'granted' : 'denied'
    };

    // GA JUŻ DZIAŁA => TYLKO AKTUALIZACJA ZGÓD
    if (ReactGA.isInitialized) {
        ReactGA.gtag('consent', 'update', consentState);
        return;
    }

    // BRAK ZGODY NA COKOLWIEK => NIE ŁADUJEMY GTAG
    if (!analytics && !advertising) return;

    // STAN DOMYŚLNY + AKTUALNY WYBÓR => DO dataLayer PRZED config (ReactGA.initialize zostawia istniejący dataLayer)
    const w: any = window;
    w.dataLayer = w.dataLayer || [];
    // gtag musi wrzucać obiekt arguments (nie tablicę), tak jak oryginalny snippet Google
    w.gtag = w.gtag || function () { w.dataLayer.push(arguments); };
    w.gtag('consent', 'default', {
        'ad_storage': 'denied',
        'ad_user_data': 'denied',
        'ad_personalization': 'denied',
        'analytics_storage': 'denied'
    });
    w.gtag('consent', 'update', consentState);

    // send_page_view: false => pageview wysyłamy sami (trackPageview), inaczej pierwsza strona liczyłaby się 2 razy
    ReactGA.initialize(GA_MEASUREMENT_ID, {gtagOptions: {send_page_view: false}});
    console.log("Google Analytics initialized");
}



// WEBPACK FOOTER //
// ./src/services/google-analytics-service.ts